import TrainerDetail from '../components/trainer/TrainerDetail';
import Options from '../components/user/Options';

export default [
  {
    name: 'TrainerDetail',
    path: '/you',
    component: TrainerDetail,
  },
  {
    name: 'Options',
    path: '/options',
    component: Options,
  },
]
